import React from 'react';
import { ReactComponent as Logo } from 'assets/icons/brand/fs-logotype.svg';
import { useHistory } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars';
import cn from 'classnames';
import { Fade } from '@material-ui/core';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import { UserBillingType, UserRole } from 'globals/types';
import { useRole } from 'globals/hooks/useRole';
import { useBillingType } from 'globals/hooks/useBillingType';
import {
  Backdrop,
  ContentBox,
  LogoContainerBox,
  StyledIconButton,
  WrapperBox,
} from './SidePanel.style-elements';
import NavMenu from './NavMenu';
import { getScrollbarsStyle, useStyles } from './SidePanel.style';
import UpgradeBox from './UpgradeBox';

interface SidePanelProps {
  active: boolean;
  id: string;
  onClose: () => void;
}

const SidePanel: React.FC<SidePanelProps> = ({
  active,
  id,
  onClose: handleClose,
}) => {
  const { isUpgraded } = useAppContext();
  const history = useHistory();
  const { active: activeClass } = useStyles();
  const scrollbarsStyle = getScrollbarsStyle();
  const handleClick = (): void => {
    history.push(Routes.ROOT);
  };
  const isAdminOrAccountant = useRole([UserRole.ADMIN, UserRole.ACCOUNTANT]);
  const isBillingTypeExcluded = useBillingType(UserBillingType.EXCLUDED);
  const showUpgradeBox =
    !isUpgraded && !isBillingTypeExcluded && isAdminOrAccountant;
  return (
    <>
      <Fade in={active} timeout={300}>
        <Backdrop onClick={handleClose} />
      </Fade>
      <WrapperBox id={id} className={cn({ [activeClass]: active })}>
        <Scrollbars
          style={scrollbarsStyle}
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
        >
          <ContentBox>
            <LogoContainerBox>
              <StyledIconButton onClick={handleClick}>
                <Logo />
              </StyledIconButton>
            </LogoContainerBox>
            <NavMenu onNavItemClick={handleClose} />
            {showUpgradeBox && <UpgradeBox />}
          </ContentBox>
        </Scrollbars>
      </WrapperBox>
    </>
  );
};

export default SidePanel;
